var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKiosk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 238,
    viewBox: "0 0 140 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 238,
    fill: "black",
    fillOpacity: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 238,
    fill: "black",
    fillOpacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136 0H4C1.79086 0 0 1.79086 0 4V234C0 236.209 1.79086 238 4 238H15.4201C17.2027 238 18.7702 236.82 19.2637 235.107L24.3312 217.518C24.8247 215.805 26.3922 214.625 28.1749 214.625H113.243C115.026 214.625 116.593 215.805 117.087 217.518L122.154 235.107C122.647 236.82 124.215 238 125.998 238H136C138.209 238 140 236.209 140 234V4C140 1.79086 138.209 0 136 0Z",
    fill: "#DFE6EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.3417,
    y: 11.3333,
    width: 117.316,
    height: 191.958,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 193,
    fill: "black",
    fillOpacity: 0,
    transform: "translate(11 11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 11H14C12.3431 11 11 12.3431 11 14V201C11 202.657 12.3431 204 14 204H126C127.657 204 129 202.657 129 201V14C129 12.3431 127.657 11 126 11Z",
    fill: "#59A3CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 204L126 11C127.657 11 129 12.3431 129 14V201C129 202.657 127.657 204 126 204H63Z",
    fill: "#4391BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126 11H14C12.3431 11 11 12.3431 11 14V107L126 11Z",
    fill: "#99C5DF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 176.5,
    width: 93,
    height: 15,
    rx: 3.5,
    fill: "#E9EDEE",
    stroke: "#C5D2DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 23.5,
    width: 13,
    height: 53,
    rx: 3.5,
    fill: "#E9EDEE",
    stroke: "#C5D2DA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 103.5,
    y: 85.5,
    width: 13,
    height: 13,
    rx: 3.5,
    fill: "#E9EDEE",
    stroke: "#C5D2DA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.84f0564c523e26de2a28f710ce82d74b.svg";
export { ForwardRef as ReactComponent };